export const MERCHANTS = [
    {
        id: "parknshop", name: "百佳 ParknShop", icon: "🛒",
        emailDomain: "@parknshop.com.hk", color: "#e63946",
        regions: [
            {
                name: "港島", branches: [
                    { id: "ps-hki-pfl", name: "薄扶林分店", address: "薄扶林道 123 號" },
                    { id: "ps-hki-cw", name: "柴灣分店", address: "柴灣道 88 號" },
                    { id: "ps-hki-cwb", name: "銅鑼灣分店", address: "銅鑼灣百德新街 18 號" },
                ]
            },
            {
                name: "九龍", branches: [
                    { id: "ps-kln-fes", name: "又一城店", address: "又一城購物中心 G07" },
                    { id: "ps-kln-mok", name: "旺角店", address: "旺角西洋菜南街 55 號" },
                    { id: "ps-kln-tko", name: "將軍澳店", address: "將軍澳廣場 2/F" },
                ]
            },
            {
                name: "新界", branches: [
                    { id: "ps-nt-shatin", name: "沙田新城市店", address: "新城市廣場 1 期 LG1" },
                    { id: "ps-nt-tuen", name: "屯門店", address: "屯門市廣場 1 期 2/F" },
                ]
            },
        ],
    },
    {
        id: "wellcome", name: "惠康 Wellcome", icon: "🏪",
        emailDomain: "@wellcome.com.hk", color: "#2a9d8f",
        regions: [
            {
                name: "港島", branches: [
                    { id: "wc-hki-hv", name: "跑馬地店", address: "跑馬地山光道 1 號" },
                    { id: "wc-hki-adm", name: "金鐘店", address: "太古廣場 1/F" },
                ]
            },
            {
                name: "九龍", branches: [
                    { id: "wc-kln-tst", name: "尖沙咀店", address: "海港城商場 G25" },
                    { id: "wc-kln-klt", name: "九龍塘店", address: "又一城商場 L2-08" },
                ]
            },
            {
                name: "新界", branches: [
                    { id: "wc-nt-st", name: "馬料水店", address: "沙田馬料水村道 3 號" },
                    { id: "wc-nt-tai", name: "大埔店", address: "大埔超級城 A 區 2/F" },
                ]
            },
        ],
    },
    {
        id: "7eleven", name: "7-Eleven", icon: "🏬",
        emailDomain: "@7-eleven.com.hk", color: "#f77f00",
        regions: [
            {
                name: "港島", branches: [
                    { id: "7e-hki-cen", name: "中環站店", address: "中環地鐵站 C 出口" },
                    { id: "7e-hki-wan", name: "灣仔店", address: "灣仔莊士敦道 168 號" },
                ]
            },
            {
                name: "九龍", branches: [
                    { id: "7e-kln-mong", name: "旺角朗豪坊店", address: "朗豪坊商場 5/F" },
                    { id: "7e-kln-tw", name: "荃灣店", address: "荃灣荃景圍 12 號" },
                ]
            },
        ],
    },
    {
        id: "developer", name: "🛠️ Developer", icon: "🛠️",
        emailDomain: "@aeye.dev", color: "#6366f1",
        regions: [
            {
                name: "A-EYE 總部", branches: [
                    { id: "dev-main", name: "主系統帳戶", address: "A-EYE HQ" },
                ]
            },
        ],
    },
];